import React from 'react';

const SessionContext = React.createContext({
  getSession: () => {},
  authorizations: {},
});

export default SessionContext;
